// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nc-c";
export var backButton = "_nc-4";
export var backIcon = "_nc-5";
export var chevronShortcut = "_nc-6";
export var container = "_nc-1";
export var editor = "_nc-8";
export var editorWrapper = "_nc-7";
export var prefix = "_nc-2";
export var searchIcon = "_nc-3";
export var suffix = "_nc-9";
export var suffixContent = "_nc-a";
export var suffixText = "_nc-b";
export var wrapper = "_nc-0";